import { MenuItem, Select } from "@mui/material";
import type { FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import {
  formatAnnuallyRepeat,
  formatMonthlyRepeat,
  formatWeeklyRepeat,
} from "../../../utils/iso8601";
import type { Event, OptionalInterval } from "../types";

export const RepeatSelect: FC<{
  repeat: Event["repeat"] | "custom";
  setRepeat: (repeat: Event["repeat"] | "custom") => void;
}> = ({ repeat, setRepeat }) => {
  const { control, getValues } = useFormContext<Event>();

  useWatch({ control, name: "date" });
  const date = getValues("date");

  return (
    <Select<Event["repeat"] | "custom">
      value={repeat}
      onChange={(e) => {
        const value = e.target.value as OptionalInterval;
        setRepeat(value);
      }}
      slotProps={{
        input: {
          "data-analytics-id": "create-event-form-repeat-select",
        },
      }}
    >
      <MenuItem value="never" data-analytics-id="create-event-form-repeat-select-never">
        Doesn’t repeat
      </MenuItem>
      <MenuItem value="1 week" data-analytics-id="create-event-form-repeat-select-weekly">
        {formatWeeklyRepeat(date)}
      </MenuItem>
      <MenuItem value="1 month" data-analytics-id="create-event-form-repeat-select-monthly">
        {formatMonthlyRepeat(date)}
      </MenuItem>
      <MenuItem value="1 year" data-analytics-id="create-event-form-repeat-select-annually">
        {formatAnnuallyRepeat(date)}
      </MenuItem>
      <MenuItem value="custom" data-analytics-id="create-event-form-repeat-select-custom">
        Custom
      </MenuItem>
    </Select>
  );
};
